import { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import classNames from 'classnames'
import Tappable from 'react-tappable'
import { Media } from 'react-bootstrap'

import { helloBabyPostPath } from 'lib/urls'
import ImageWithPlaceholderColor from 'components/image-with-placeholder-color'

import css from './post-teaser.scss'

class PostTeaser extends Component {
  render() {
    let { isResponsive, post, index } = this.props
    const { url, thumbnailUrl } = post.featuredImage

    let imageClasses = classNames('hover-overlay hover-lighten', {
      [css.postThumbnailMdResponsive]: isResponsive,
      [css.postThumbnailSm]: !isResponsive,
    })

    return (
      <Tappable
        component="div"
        className={css.postTeaser}
        classes={{ active: css.active }}
      >
        <Link className="text-body" to={helloBabyPostPath(post.slug)}>
          <Media>
            <Media.Left>
              <div className={imageClasses}>
                {post.featuredImage && (
                  <ImageWithPlaceholderColor
                    aspectWidth={3}
                    aspectHeight={2}
                    colorIndex={index}
                    src={thumbnailUrl.includes('babylist') ? thumbnailUrl : url}
                    alt={post.featuredImage.description}
                    data-pin-nopin="true"
                  />
                )}
              </div>
            </Media.Left>

            <Media.Body className={classNames(this.props.bodyClassName, 'pvn')}>
              <div className={`media-heading ${css.postTitle}`}>
                {post.title}
              </div>
              {isResponsive && <p className={'serif mbn'}>{post.teaser}</p>}
            </Media.Body>
          </Media>
        </Link>
      </Tappable>
    )
  }
}

PostTeaser.propTypes = {
  bodyClassName: PropTypes.string,
  isResponsive: PropTypes.bool.isRequired,
  post: PropTypes.shape({
    featuredImage: PropTypes.shape({
      description: PropTypes.string,
      thumbnailUrl: PropTypes.string.isRequired,
    }),
    slug: PropTypes.string.isRequired,
    teaser: PropTypes.string,
    title: PropTypes.string.isRequired,
  }),
}

PostTeaser.defaultProps = {
  isResponsive: true,
}

export default PostTeaser
